import React from 'react';

import Header from '../../layout/Header.jsx';
import ListPaymentRecords from '../../lists/ListPaymentRecords.jsx';

const PagePaymentRecords = () => (
  <div>
    <Header>Payment Records</Header>
    <ListPaymentRecords />
  </div>
);

export default PagePaymentRecords;
